<template>
  <p
    class="ocorrencia-item"
    style="font-weight: normal"
    @click="click"
  >
    <span class="title">
      {{ row.guia.descricaoTipoServico }}
    </span>
    <span class="sub-item">
      N° da Guia: {{ row.guia.numeroPedido }}
    </span>
    <span class="sub-item">
      Protocolo: {{ row.guia.numeroProtocolo }}
    </span>
    <span class="sub-item">
      Beneficiário: {{ row.nomeBeneficiario }}
    </span>
    <span class="sub-item">
      Solicitante: {{ row.solicitante.nomeSolicitante }}
    </span>
    <span class="sub-item">
      Quant. itens: {{ row.guia.quantidadeEventos }}
    </span>
  </p>
</template>
<script>
export default {
  name: 'AutorizacaoItem',
  props: ['column', 'row'],
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
